module.exports = __webpack_public_path__ + "img/img_txt_noti_hand.fd979473.svg";